import { useSelector, useDispatch } from 'react-redux';
import { useGetCreditBalanceQuery } from '../redux/apis/endpoints/creditApi';
import {
  deductCreditOptimistic,
  refundCreditOptimistic,
  confirmOperation,
  setCreditBalance
} from '../redux/slices/creditSlice';
import {
  selectCreditBalance,
  selectDaysUntilReset,
  selectMaxCredits,
  selectCreditLoading,
  selectHasCredits
} from '../redux/selectors/creditSelectors';

// All AI generations cost 1 credit
export const CREDIT_COST = 1;

export const useCredits = () => {
  const dispatch = useDispatch();
  const { refetch } = useGetCreditBalanceQuery();
  
  const balance = useSelector(selectCreditBalance);
  const daysUntilReset = useSelector(selectDaysUntilReset);
  const maxCredits = useSelector(selectMaxCredits);
  const isLoading = useSelector(selectCreditLoading);
  const hasCredits = useSelector(selectHasCredits);
  
  return {
    balance,
    daysUntilReset,
    maxCredits,
    isLoading,
    hasCredits,
    refetch,
    deductCredit: (amount = 1) => dispatch(deductCreditOptimistic({ amount })),
    refundCredit: (amount = 1) => dispatch(refundCreditOptimistic({ amount })),
    confirmOperation: () => dispatch(confirmOperation()),
    updateBalance: (data) => dispatch(setCreditBalance(data)),
    CREDIT_COST
  };
};

export default useCredits;
